import { AlertNotification, Breed } from '@app/core/models';
import { Localization } from '@app/core/models/localization';
import { Tool } from '@app/shared/utils';
import { createAction, props } from '@ngrx/store';
import { RcToastPropsExtended } from './core.state';

/**
 * Action to handle blocking loader display
 */
export const toggleLoader = createAction('[Core] Toggle Loader', props<{ value: boolean; transparent?: boolean }>());
/**
 * Action to handle popin loader display
 */
export const togglePopinLoader = createAction('[Core] Toggle Popin Loader', props<{ value: boolean }>());
/**
 * Action to handle progress bar display
 */
export const toggleProgressBar = createAction('[Core] Toggle Progress Bar', props<{ value: boolean }>());
/*
 * Actions to load global localization data
 */
export const getLocalization = createAction('[Core] Get Localization');
export const getLocalizationSuccess = createAction('[Core] Get Localization Success', props<{ localization: Localization }>());
/**
 * Set tool when starting new consultation
 * Used by the token interceptor (but might be used more once router flow is deleted)
 */
export const setTool = createAction('[Core] Set Tool', props<{ tool: Tool; tool_flow_id: string }>());
/**
 * Set prev tool when leaving flow
 * Used by the token interceptor (but might be used more once router flow is deleted)
 */
export const setPrevTool = createAction('[Core] Set Prev Tool', props<{ prevTool: Tool | null }>());
/**
 * Set tool when leaving a consultation
 * Used by the token interceptor (but might be used more once router flow is deleted)
 */
export const clearTool = createAction('[Core] Clear Tool');
/**
 * Action used to set breeds;
 * Currently dispatched from legagy EnumService.fetchBreed for compatibility,
 * awaiting full migration to store
 */
export const setBreeds = createAction('[Core] Set breeds', props<{ breeds: Breed[] }>());
/**
 * Action used to set alert messages;
 */
export const setAlert = createAction('[Core] Set Alert', props<{ alert: AlertNotification }>());
/**
 * Action used to remove an alert messages;
 */
export const removeAlert = createAction('[Core] Remove Alert', props<{ alert: AlertNotification }>());
/**
 * Action used to remove multiple alert messages
 * specify ids if you want to filter the messages to remove
 * otherwise all message are removed
 */
export const resetAlerts = createAction('[Core] Reset Alerts', props<{ ids: string[] }>());
/**
 * Action used to remove all success alert messages
 */
export const removeSuccessAlerts = createAction('[Core] Remove Success Alerts');

export const triggerNavigation = createAction('[Core] Trigger Navigation', props<{ paths: string[] }>());

/**
 * Action to set stepper's active index
 */
export const setStepperActiveStep = createAction(`[Core] Set Stepper's Active Index`, props<{ index: number }>());
/**
 * Action used to set toast;
 */
export const setToast = createAction('[Core] Set Toast', props<{ toast: RcToastPropsExtended }>());
/**
 * Action used to remove an toast;
 */
export const removeToast = createAction('[Core] Remove Toast', props<{ id: string }>());
